import { render, staticRenderFns } from "./buyOk.vue?vue&type=template&id=7d64b3e9&scoped=true"
import script from "./buyOk.vue?vue&type=script&lang=js"
export * from "./buyOk.vue?vue&type=script&lang=js"
import style0 from "./buyOk.vue?vue&type=style&index=0&id=7d64b3e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64b3e9",
  null
  
)

export default component.exports